import { format } from "date-fns";
import { signal } from "@preact/signals-react";
import { es } from "date-fns/locale";

import Calendar from "componentsv2/widgets/Calendar";
import TimeSelector from "componentsv2/widgets/TimeSelector";
import { ClockIcon } from "components/Icons";
import FormField from "./FormField";
import { cn, colors } from "tools/ui";
import { theme } from "theme/theme";

const FORMAT = "dd.MMM.yyyy";
const FORMAT_TIME = "kk:mm aaa";

function DatetimePicker({
  name,
  label,
  onChange,
  field,
  readOnly,
  data,
  minDate,
  maxDate,
  colSpan,
  model,
}) {
  const showPop = signal(false);
  const showPopTime = signal(false);
  const timeData = signal(data.value);
  const dateData = signal(data.value);

  let _color = "bg-white";
  if (readOnly) {
    _color = colors.readOnly;
  }

  function handlePop(e) {
    e.preventDefault();
    if (readOnly) return;
    showPop.value = true;
  }

  function handlePopTime(e) {
    e.preventDefault();
    if (readOnly) return;
    showPopTime.value = true;
  }

  function handleDate(value, part) {
    let fullDate = new Date(+data.value);
    if (part === "time") {
      fullDate.setHours(value.getHours());
      fullDate.setMinutes(value.getMinutes());
    } else {
      fullDate.setFullYear(value.getFullYear());
      fullDate.setMonth(value.getMonth());
      fullDate.setDate(value.getDate());
    }
    data.value = fullDate;
    if (onChange) {
      onChange(name, fullDate);
    }
  }

  return (
    <FormField
      label={label}
      name={name}
      required={field?.required}
      colspan={colSpan}
      model={model}
    >
      <div className="flex min-w-60">
        <div
          onClick={handlePop}
          className={cn(
            "grow-7 text-right text-base p-2 justify-between mr-1",
            theme.border,
            theme.textColor,
            theme.input.height,
            _color,
          )}
        >
          <span className="font-normal">
            {dateData.value && format(dateData.value, FORMAT, { locale: es })}
          </span>
        </div>
        <Calendar
          name={name}
          mode="single"
          selected={data.value}
          onSelect={handleDate}
          show={showPop}
        />
        <button
          onClick={handlePopTime}
          className={cn(
            "flex grow-3 text-base p-2 justify-between min-w-[120px]",
            theme.border,
            theme.textColor,
            theme.input.height,
            _color,
          )}
        >
          <span className="font-normal">
            {timeData.value &&
              format(timeData.value, FORMAT_TIME, { locale: es })}
          </span>
          <ClockIcon className="text-blue-300 w-5 h-5 fill-current" />
        </button>
        <TimeSelector
          show={showPopTime}
          handleDate={handleDate}
          dateTime={timeData}
        />
      </div>
    </FormField>
  );
}

export default DatetimePicker;
